import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { ApplicationCertificationService } from "../../../shared/services/application-certification.service";
import { ApplicationCertificationResponse } from "../../../shared/models/application-certification.model";

@Injectable({
    providedIn: 'root',
})
export class GetApplicationCertificationResolver implements Resolve<ApplicationCertificationResponse> {

    constructor(
        private certificationService: ApplicationCertificationService,
    ) { }

    resolve(route: ActivatedRouteSnapshot): Observable<ApplicationCertificationResponse> {
        const applicationId = route.params['applicationId'] ? route.params['applicationId'] : route.parent?.params['applicationId'];
        return this.certificationService.getCertification(applicationId);
    }
}